/**
 *
 * AdministratorBCForm
 *
 */

import {TenantForm} from "pages/Rules/TenantView";


export class TenantForm14326 extends TenantForm {
    getFields() {
        let fields = super.getFields()

        const contentIndex = fields.findIndex((field) => field.name === 'content');
        fields[contentIndex].grid = {sm: 12}

        const fileIndex = fields.findIndex((field) => field.name === 'file');
        fields[fileIndex].previewImage = null
        fields[fileIndex].grid = {sm: 6}
        return fields
    }
}